import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { SignoAuditoriaService } from '@services/auditoria/signo-auditoria.service';
import { InscripcionesAuditoriaService } from '@services/auditoria/inscripciones-auditoria.service';
import { coincideFuzzy } from '@shared/utils/fuzzy-search.util';
import {
    GrupoInscripcion,
    agruparPorIntento,
    iconoAccionInscripcion,
    labelAccionInscripcion,
    resumenEvento,
} from '../inscripciones-auditoria.diccionario';

@Component({
    selector: 'app-inscripciones-auditoria-listado',
    templateUrl: './inscripciones-auditoria-listado.component.html',
    styleUrls: ['./inscripciones-auditoria-listado.component.scss'],
})
export class InscripcionesAuditoriaListadoComponent implements OnInit {

    @ViewChild(MatSort) set matSort(ms: MatSort) {
        if (ms) { this.dataSource.sort = ms; }
    }
    @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
        if (mp) { this.dataSource.paginator = mp; }
    }

    // Un renglón por intento de inscripción (traceId), no por evento.
    displayedColumns: string[] = ['usuario', 'solicitud', 'pasos', 'ultimoPaso', 'resultado', 'fecha', 'acciones'];
    dataSource: MatTableDataSource<GrupoInscripcion> = new MatTableDataSource();

    flagLoaded: boolean = false;
    termino: string = '';

    labelAccionInscripcion = labelAccionInscripcion;
    iconoAccionInscripcion = iconoAccionInscripcion;
    resumenEvento = resumenEvento;

    constructor(
        private router: Router,
        private signoAuditoriaService: SignoAuditoriaService,
        private inscripcionesAuditoria: InscripcionesAuditoriaService,
    ) {
        this.dataSource.filterPredicate = (grupo, filter) => {
            const texto = [
                grupo.nombre,
                grupo.email,
                grupo.solicitudId,
                grupo.traceId,
                grupo.resultado,
                labelAccionInscripcion(grupo.ultimo.accion),
                resumenEvento(grupo.ultimo),
            ].join(' ');
            return coincideFuzzy(texto, filter);
        };

        this.dataSource.sortingDataAccessor = (grupo, columna) => {
            switch (columna) {
                case 'usuario':
                    return (grupo.nombre || grupo.email || '').toLowerCase();
                case 'solicitud':
                    return grupo.solicitudId || '';
                case 'pasos':
                    return grupo.totalPasos;
                case 'ultimoPaso':
                    return labelAccionInscripcion(grupo.ultimo.accion).toLowerCase();
                case 'resultado':
                    return grupo.resultado || '';
                case 'fecha':
                    return grupo.fecha || '';
                default:
                    return '';
            }
        };
    }

    async ngOnInit(): Promise<void> {
        if (!(await this.signoAuditoriaService.puedeAccederAuditoria())) {
            this.signoAuditoriaService.setAccesoDenegado(true);
            this.router.navigateByUrl('/configurar-administracion');
            return;
        }
        await this.cargarEventos();
    }

    private async cargarEventos(): Promise<void> {
        const eventos = await this.inscripcionesAuditoria.getEventos();
        this.dataSource.data = agruparPorIntento(eventos);
        this.flagLoaded = true;
    }

    aplicarFiltro(termino: string): void {
        this.termino = termino;
        this.dataSource.filter = (termino || '').trim();
        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

    verDetalle(grupo: GrupoInscripcion): void {
        // El detalle arma el timeline completo por traceId a partir de un evento.
        this.signoAuditoriaService.setEventoSeleccionado(grupo.ultimo);
        this.router.navigateByUrl('/auditoria-inscripciones-detalle');
    }

    volver(): void {
        this.router.navigateByUrl('/menu-auditoria');
    }
}
